import api from "./api";

export async function getPublicGenerationAttempts(take = 100) {
    const { data } = await api.get("/website-v2/admin/public-generation-attempts", {
        params: { take }
    });

    return data;
}